module.exports = __webpack_public_path__ + "img/sticker-0-2.803ae0f6.svg";